import { useEffect, useRef } from "react";
import { TopBar } from "../../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../../config/routeConfig";
import { useNavigate, useParams } from "react-router-dom";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { DateRangePicker } from "rsuite";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { getUniverseMembersAction } from "../../../actions/universeMembers";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { AgGridReact } from "ag-grid-react";
import { getUniverseListAction } from "../../../actions/universeListAction";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { sbaAxios } from "../../../utils/sbaAxios";
import { getUniverseReturnsApi } from "../../../../config/apiConfig";
import moment from "moment/moment";
import download from '../../../../Images/download.svg';

import { exportToExcel, exportToExcelUsingRef } from "../../../utils/excelExporter";
import { SBDateRangePicker } from "../../../UiComponents/SBDateRangePicker";

const PercentageRenderer = ({ value }) => {
  if (value === null) {
    return <span></span>;
  }
  return <span>{(parseFloat(value) * 100).toFixed(4)}%</span>;
};
const DateRenderer = ({ value }) => {
  if (value === null) {
    return <span></span>;
  }
  return <span>{moment(value).format("MMM YYYY")}</span>;
};

export const UniverseAnalytics = () => {
  const param = useParams();
  const universeId = param.UniverseId;
  const dispatch = useDispatch();
  
  const Gstate = useSelector((state) => state);
  const universeList = Gstate.AnalyticsReporting.universeList || [];
  const UniverseMember = Gstate.AnalyticsReporting.memberList || {};
  console.log(UniverseMember,'UniverseMember');
  useEffect(() => {
    document.title = `Universe Analytics`;
    if(UniverseMember.UniverseId!==parseInt(param.UniverseId))
    {
      dispatch(getUniverseMembersAction(universeId,UniverseMember));
    }
    if(universeList.length===0)
    {
      dispatch(getUniverseListAction());
    } 
  }, [universeId]);

  const Level = [{ BreadCrumb: "Universe", Routes: `${UrlPath.UniverseList}` }];
  return (
    <>
      <TopBar label={"Universe Analytics"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="p-3">
          <Tabs defaultActiveKey="Returns">
            <Tab eventKey="Returns" title="Returns" className="detail">
              <>
                <UniverseReturns />
              </>
            </Tab>
            <Tab eventKey="Statistics " title="Statistics" className="detail">
              <div className="p-3">Under development</div>
            </Tab>
          </Tabs>
        </div>
      </div>{" "}
    </>
  );
};
export const UniverseReturns = () => {
  const param = useParams();
  const universeId = param.UniverseId;
  const history = useNavigate();

  // useselector const
  const Gstate = useSelector((state) => state);
  const universeList = Gstate.AnalyticsReporting.universeList || [];
  const UniverseMember = Gstate.AnalyticsReporting.memberList || {};

  const commonDate = UniverseMember?.CommonReturnRange?.split(" - ") || [
    new Date(),
    new Date(),
  ];
  const commonDateRange = [new Date(commonDate[0]), new Date(commonDate[1])];
  const maxDate = UniverseMember?.MaxReturnRange?.split(" - ") || [
    new Date(),
    new Date(),
  ];
  const maxDateRange = [new Date(maxDate[0]), new Date(maxDate[1])];
  // component const
  const orientationList = [
    { id: 1, text: "Vertical" },
    { id: 2, text: "Horizontal" },
  ];
  const ReturnsRef = useRef();

  //component state
  const [selectedUniverse, setSelectedUniverse] = useState(UniverseMember);
  const [selectedOrien, setSelectedOrien] = useState(orientationList[0]);
  const [selectRange, setSelectedRange] = useState("common");
  const [selectedDateRange, setSelectedDateRange] = useState(commonDateRange);
  const [loading, setLoading] = useState(true);
  const [colDef, setColDef] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [gridLoading,setGridLoading]=useState(true);
  useEffect(() => { 
    if(UniverseMember.UniverseId===parseInt(universeId) )
    {
      setSelectedUniverse(UniverseMember);
      setLoading(false);
      setGridLoading(true);
      getUniverseReturns();
    }
  }, [UniverseMember]);

  const changeSelectedRange = (type) => {
    setSelectedRange((value) => {
      if (value === type) return "custom";
      else return type;
    });
    if (type === "max") {
      setSelectedDateRange(maxDateRange);
    }
    if (type === "common") {
      setSelectedDateRange(commonDateRange);
    }
  };

  function getVertReturnColDef(data) {
    const outPut = [
      { field: "Date", headerName: "Date", cellRenderer: DateRenderer },
    ];
    const entityList = data?.EntityList || [];
    const entityDefs = entityList.map((item) => ({
      field: `Entity_${item.EntityId}`,
      headerName: item.EntityName,
      cellRenderer: PercentageRenderer,
      cellStyle: ({ value }) => ({
        textAlign: "right",
        color: value < 0 ? "red" : "",
      }),
    }));
    const def = [...outPut, ...entityDefs];
    return def;
  }
  function getVertReturnRowData(data) {
    const entityList = data?.EntityList || [];
    const formattedReturnsOnly = entityList.map((item) => {
      return item.EntityReturns.map((eachReturn) => {
        const EntityId = `Entity_${item.EntityId}`;
        return {
          [EntityId]: eachReturn.RoR,
          Date: eachReturn.ReturnDate,
        };
      });
    });
    const combinedData = formattedReturnsOnly.reduce((result, dataArray) => {
      dataArray.forEach((record) => {
        const existingRecord = result.find((r) => r.Date === record.Date);
        if (existingRecord) {
          Object.assign(existingRecord, record);
        } else {
          result.push(record);
        }
      });

      return result;
    }, []);
    return combinedData;
  }
  function getHoriReturnColDef(data) {
    const outPut = [{ field: "Name", headerName: "Entity" }];
    const entityList = data?.EntityList || [];
    const getReturnsDates = entityList[0].EntityReturns.map((subItem) => ({
      field: `${subItem.ReturnDate}`,
      headerName: moment(subItem.ReturnDate).format("MMM YYYY"),
      cellRenderer: PercentageRenderer,
      cellStyle: ({ value }) => ({
        textAlign: "right",
        color: value < 0 ? "red" : "",
      }),
    }));
    const def = [...outPut, ...getReturnsDates];
    return def;
  }
  function getHoriReturnRowData(data) {
    const entityList = data?.EntityList || [];
    const formattedReturnsOnly = entityList.map((item) => {
      return item.EntityReturns.map((eachReturn) => {
        const date = eachReturn.ReturnDate;
        return {
          [date]: eachReturn.RoR,
          Name: item.EntityName,
          Id: item.EntityId,
        };
      });
    });
    const combinedData = formattedReturnsOnly.reduce((result, dataArray) => {
      dataArray.forEach((record) => {
        const existingRecord = result.find((r) => r.Id === record.Id);
        if (existingRecord) {
          Object.assign(existingRecord, record);
        } else {
          result.push(record);
        }
      });

      return result;
    }, []);

    return combinedData;
  }

 
  useEffect(()=>{
    if(selectedOrien.id===1)
    {
      setRowData(getVertReturnRowData(apiData));
      setColDef(getVertReturnColDef(apiData));
    }
    else if(selectedOrien.id===2)
    {
      setRowData(getHoriReturnRowData(apiData));
      setColDef(getHoriReturnColDef(apiData));
    }
  },[apiData,selectedOrien]);

  const getUniverseReturns = () => {
    setGridLoading(true);
    const UniverseID = selectedUniverse.UniverseId;
    const StartDate = selectedDateRange[0].toISOString();
    const EndDate = selectedDateRange[1].toISOString();
    // const orentationID = selectedOrien.id;
    // const rangeType = selectRange;
    sbaAxios({
      url: `${getUniverseReturnsApi}${UniverseID},${StartDate},${EndDate},${1}`,
    })
      .then((response) => {
        setApiData(response);
        setGridLoading(false);
      }
      )
      .catch((error) => {
        setGridLoading(false);
        
        console.log(error, "error fetching the universe returns");
      });
  };
  const defaultDef = {
    flex: 1,
    minWidth: 200,
    wrapHeaderText: true,
      autoHeaderHeight: true,
      editable: false,
      cellDataType: false,
      singleClickEdit: true,
      resizable:true
  };
  const universeDDchanged = (e) => {
    if (e.value) {
      history(`${UrlPath.UniverseAnalytics}${e.value.UniverseId}`);
      setSelectedUniverse(e.value);
    }
  };
  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <div className="p-3">
            <div className="row">
              <div className="col-md-3">
                <label className="label">Select Universe</label>
                <SBAComboBox
                  data={universeList}
                  value={selectedUniverse}
                  textField={"UniverseName"}
                  valueField={"UniverseId"}
                  onChange={(e) => {
                    universeDDchanged(e);
                  }}
                />
              </div>
              <div className="col-md-3">
                <label className="label">Select Output Format</label>
                <SBAComboBox
                  data={orientationList}
                  value={selectedOrien}
                  onChange={(e) => {
                    setSelectedOrien(e.value);
                  }}
                  textField={"text"}
                  valueField={"id"}
                />
              </div>
              <div className="col-md-3">
                <label className="label">Select Date Range</label>
                {/* <DateRangePicker
                  className="SbaDateRage text-dark"
                  placeholder="Select Date Range"
                  format="MM/dd/yyyy"
                  block
                  character=" - "
                  value={selectedDateRange}
                  onChange={(e) => {
                    setSelectedDateRange(e);
                    setSelectedRange(null);
                  }}
                /> */}
                <div style={{width:"70%"}}>
                <SBDateRangePicker 
                value={{start:selectedDateRange[0],end:selectedDateRange[1]}}
                onChange={(e)=>{
                    if(e)
                    {

                        const newStartDate = e.value.start !== null ? e.value.start : selectedDateRange[0];
                        const newEndDate = e.value.end !== null ? e.value.end : selectedDateRange[1];
                        setSelectedDateRange([newStartDate, newEndDate])
                    }
                }}
                />

                </div>
               
              </div>
              <div className="col-md-3 row-items">
                <button
                  className="p-sm-btn"
                  onClick={() => {
                    getUniverseReturns();
                  }}
                >
                  Go
                </button>
              </div>
            </div>
            <div className="my-3">
            <button
                className={`non-gappable-button  ${
                  selectRange === "max" ? "selected-non-gappable-button" : ""
                }`}
                onClick={() => {
                  changeSelectedRange("max");
                }}
              >
                Max Range
              </button>
              <button
                className={`non-gappable-button  ${
                  selectRange === "common" ? "selected-non-gappable-button" : ""
                }`}
                onClick={() => {
                  changeSelectedRange("common");
                }}
              >
                Common Range
                              </button>
                              
                              <div id="ExportButton" style={{ paddingLeft: "89%" }}>
                                  <button type="button" className="p-sm-btn mx-1"  onClick={() => { exportToExcelUsingRef(ReturnsRef, "Universe Analytics.xlsx") }}><img src={download} alt="" />Export</button>
              </div>
              <div
                className="p-3 ag-theme-alpine"
                style={{ width: "100%", height: "600px" }}
              >
                {gridLoading ? <><LoadingScreen/></> : 
                <AgGridReact
                  columnDefs={colDef}
                  rowData={rowData}
                  ref={ReturnsRef}
                  defaultColDef={defaultDef}
                />}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
